import type { SxStyle } from '@aibees/shared/theme';
import { cardBase } from '../testimonial-card-shared';

export const root: SxStyle = {
  ...cardBase,
  width: '100%',
  p: 0,
  textAlign: 'left',
  overflow: 'hidden',
};

export const thumbnail: SxStyle = {
  position: 'relative',
  width: '100%',
  aspectRatio: '16 / 9',
  bgcolor: 'common.black',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
};

export const sourceBadge: SxStyle = {
  position: 'absolute',
  top: 12,
  right: 12,
};

export const body: SxStyle = {
  p: 1.5,
};

export const footerRow: SxStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 1,
};

export const titleClamp: SxStyle = {
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
};
